import { render, staticRenderFns } from "./CreateReturnReviewSubmit.vue?vue&type=template&id=22587af7"
import script from "./CreateReturnReviewSubmit.vue?vue&type=script&lang=js"
export * from "./CreateReturnReviewSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports